var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneF7A823(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96054 0.526141C2.12726 0.359327 2.3252 0.227048 2.54307 0.136763C2.76095 0.0464787 2.99449 0 3.23033 0C3.46617 0 3.69968 0.0464787 3.91755 0.136763C4.13542 0.227048 4.33336 0.359327 4.50008 0.526141L4.64239 0.690364L6.4814 3.06571C6.64917 3.27931 6.76593 3.52845 6.82284 3.79403C6.87975 4.05961 6.8753 4.33465 6.80978 4.59824L6.25151 6.78752C6.22038 6.90273 6.22019 7.0241 6.25094 7.13941C6.28169 7.25473 6.34229 7.35987 6.42665 7.44428L8.95527 9.97289C9.03979 10.0573 9.1445 10.1188 9.25946 10.1513C9.37441 10.1839 9.4958 10.1866 9.61205 10.159L11.867 9.5898C12.1307 9.5251 12.4055 9.52102 12.671 9.5779C12.9364 9.63478 13.1855 9.75113 13.3995 9.91817L15.7639 11.7572C16.1372 12.0508 16.3799 12.4797 16.4393 12.9509C16.4987 13.4221 16.3701 13.8977 16.0814 14.2748L15.9281 14.439L14.8335 15.5337C14.4597 15.9214 13.9835 16.1951 13.4604 16.323C12.9372 16.4509 12.3885 16.4277 11.878 16.2561C9.17272 15.2955 6.71571 13.7437 4.68578 11.7138C2.65586 9.68387 1.1041 7.22685 0.143439 4.52161C-0.0241836 4.01065 -0.045349 3.46294 0.0823397 2.94058C0.210028 2.41821 0.481471 1.94207 0.865904 1.56606L1.96054 0.526141Z",
    fill: "#F7A823"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneF7A823);
export default __webpack_public_path__ + "static/media/phone_f7a823.9b75dbeecdf939850abf0e21c2a8ceef.svg";
export { ForwardRef as ReactComponent };